// 税込価格を計算
export const calculatePrice = (contents) => {
  let price = 0
  if (contents) {
    contents.forEach((content) => {
      price += content.price
    })
  }
  return price
}
